// Google OAuth web client (public id, not a secret). Project: lean-by-priyanka-login
export const GOOGLE_CLIENT_ID = "454015480799-6dofasol2tvngj4qvo5gqlh8shel43om.apps.googleusercontent.com";
